import { render, staticRenderFns } from "./PcMain.vue?vue&type=template&id=7c6ed906&scoped=true"
import script from "./PcMain.vue?vue&type=script&lang=js"
export * from "./PcMain.vue?vue&type=script&lang=js"
import style0 from "./PcMain.vue?vue&type=style&index=0&id=7c6ed906&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6ed906",
  null
  
)

export default component.exports